import React, { useEffect, useState } from 'react'
import { Button, Table, Typography, Space, Image, Select, Form, Card, Row, Col, Flex } from 'antd'
import { ActionButton, AlertModal, ModuleTopHeading, SearchInput } from '../..';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

let timer;
const { Option } = Select;
const { Text } = Typography;
const JobAppliedTable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [form] = Form.useForm();
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const { jobtrackData, loadingtrackjob, filters, pagination } = useSelector(state=>state.JobtrackgetApi)
    useEffect(()=>{
        dispatch(actionsApi.getJobTrack({...filters, ...pagination, pageNo: 1}))
    },[])

    const call = (pageNo = 1, pageSize = 10) => {
        dispatch(actionsApi?.getJobTrack({ ...filters, pageNo, pageSize }))
    }

    function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getJobTrack({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const onChange = (value, row) => {
        const newStatus = value === 'Pending' ? 1 : 
        value === 'Active' ? 2 :
        value === 'InActive' ? 3 : value ;
        dispatch(actionsApi?.jobtrackstatusResponse({ id: row.id, status: newStatus }));
        dispatch(actionsApi?.updateJobtrackStatus({ id: row.id, status: newStatus }));
    };

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>First Name</Text>,
            dataIndex: 'firstName',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Last Name</Text>,
            dataIndex: 'lastName'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Email</Text>,
            dataIndex: 'email'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 1) {
                    return <Text className='pending fs-12 badge-cs'>Pending</Text>;
                } else if(status === 2){
                    return <Text className='active fs-12 badge-cs'>Active</Text>;
                } else{
                    return <Text className='inactive fs-12 badge-cs'>Inactive</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 200,
            render: (_, row) => (
                <Space>
                    <Select
                        onChange={(value) => onChange(value, row)}
                        className='fs-12'
                        defaultValue={
                            row?.status === 1 ? 'Pending' :
                            row?.status === 2 ? 'Active' :
                            row?.status === 3 ? 'InActive' : ''
                        }
                        style={{width: 100}}
                    >
                        <Option value="Active" >Active</Option>
                        <Option value="Pending">Pending</Option>
                        <Option value="InActive">InActive</Option>
                    </Select>
                    <ActionButton
                        title='View Job'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/job/detail/${row?.id}`)}}
                    />
                    <ActionButton
                        title='Delete Job'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.firstName + ' ' + row?.lastName, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    // delete job api
    const DeleteJobTrack= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.addJobapi?.DeleteJobTrack(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading 
                                level={4} 
                                name='Jobs Applied Details'
                            />
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row gutter={[16,16]} align={'middle'}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <SearchInput 
                                            name='name'
                                            placeholder='Search job'
                                            prefix={<img src='/assets/icons/search.png' width={20} />}
                                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                            onChange={(e)=> debouncedSearchHandler(e.target.value, 1,20)}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Table
                            size='large'
                            columns={columns}
                            dataSource={jobtrackData}
                            className='pagination'
                            showSorterTooltip={false}
                            scroll={{ x: 1400 }}
                            pagination={{
                                hideOnSinglePage: true,
                                total: pagination?.totalRecords,
                                pageSize: pagination?.pageSize,
                                defaultPageSize: pagination?.pageSize,
                                current: pagination?.pageNo,
                                size: "default",
                                pageSizeOptions: ['10', '20', '50', '100'],
                                onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                            }}
                            loading={
                                {
                                    ...TableLoader,
                                    spinning: loadingtrackjob
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                callBack={DeleteJobTrack}
                deletionLoading={deletionLoading}
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { JobAppliedTable }